import { LevelDataSet, LevelSelect } from 'components/Form'
import { TMLevel } from 'types'
import { AdvancedInputProps, BasicInputGroup } from '.'

export interface LevelInputProps extends AdvancedInputProps {
  value?: TMLevel
}
export const LevelInput = ({
  value,
  label,
  name,
  disabled,
  setFieldValue,
  onBlur,
  error,
  tabIndex,
}: LevelInputProps) => {
  const displayText = value?.label || '-'

  return (
    <BasicInputGroup
      name={name}
      label={label}
      error={error}
      disabled={disabled}
      display={displayText}
      input={
        <LevelSelect
          data-cy="tm-level"
          name={name}
          value={value}
          options={LevelDataSet}
          hasErrors={!!error}
          disabled={disabled}
          onChange={(level) => {
            setFieldValue(name, level.value)
            setFieldValue(`__level`, level)
          }}
          onBlur={onBlur}
          tabIndex={tabIndex}
        />
      }
    />
  )
}
